

import {
    CREATE_TOKEN_BRAND, CREATE_TOKEN_BRAND_RESET
} from "../constant/ActionType";

export default function CreatTokenDataReducers(state = {
    create_token_data: [],
    statuscode: null,
}, action) {
    switch (action.type) {
        case CREATE_TOKEN_BRAND:
            return {
                ...state,
                create_token_data: action?.data,
            };

        case CREATE_TOKEN_BRAND_RESET:
            return {
                ...state,
                create_token_data: {},
            };

        default:
    }

    return state;
}